import { Directive, Input, input, output } from "@angular/core";
import { SelectItem } from 'primeng/api';
import { SharedControl } from "../../classes/sharedcontrol";
import { Vendor } from "../../types/vendor";

@Directive() 
export abstract class PCPTradePartnerSelectorBaseComponent extends SharedControl{
    readonly marketId = input<number>(undefined);
    // TODO: Skipped for migration because:
    //  This input is inherited from a superclass, but the parent cannot be migrated.
    @Input() disabled: boolean = false;
    readonly selectionLimit = input<number>(null);
    readonly required = input<boolean>(false);
    readonly isOneOfManyRequired = input<boolean>(false);
    readonly xOfManyErrors = input<boolean>(false);
    readonly tradePartnersLoaded = output<void>();

    tradePartnersToOptions(tradePartners: Vendor[]): SelectItem[] {
        return tradePartners.map((tradePartner) => {
            const displayText =`${tradePartner.name} ${tradePartner.marketFinancialVendor.tpLawsonId}`
            return { label: displayText, value: tradePartner };
        });
    }

    sortSelectedTop(allTradePartners: Vendor[], selectedTradePartners: Vendor[]): Vendor[] {
        if (!allTradePartners || allTradePartners.length === 0) { return []; }

        const unselectedTradePartners = allTradePartners.filter((tradePartner) => !this.tradePartnerIsInSelectedTradePartners(tradePartner, selectedTradePartners));
        const selectTradePartners = allTradePartners.filter((tradePartner) => this.tradePartnerIsInSelectedTradePartners(tradePartner, selectedTradePartners));

        const alphabetically = (a: Vendor, b: Vendor) => (`${a.name} ${a.marketFinancialVendor.tpLawsonId}` > `${b.name} ${b.marketFinancialVendor.tpLawsonId}`) ? 1 : -1;
        const alphabeticallySortedUnselectedTradePartners = unselectedTradePartners.sort(alphabetically);
        const alphabeticallySortedSelectedTradePartners = selectTradePartners.sort(alphabetically);

        alphabeticallySortedUnselectedTradePartners.unshift(...alphabeticallySortedSelectedTradePartners);

        const allSortedTradePartners = alphabeticallySortedUnselectedTradePartners;

        return allSortedTradePartners;
    }

    private tradePartnerIsInSelectedTradePartners(tradePartner: Vendor, selectedTradePartners: Vendor[]): boolean {
        if(!selectedTradePartners || selectedTradePartners.length === 0) { return false; }

        return selectedTradePartners.some((selectedTradePartner) => selectedTradePartner.id === tradePartner.id);
    }

}